{
	"success": {
		"title": "Payment confirmed",
		"message": "Your payment was processed successfully. You can close this page now."
	},
	"pending": {
		"title": "Payment processing",
		"message": "We are confirming your payment. This may take a few moments."
	},
	"failed": {
		"title": "Payment not completed",
		"message": "We couldn't process your payment. Try again or use another method."
	},
	"canceled": {
		"title": "Payment canceled",
		"message": "The payment was canceled."
	},
	"unknown": {
		"title": "Status unavailable",
		"message": "We couldn't identify your payment status."
	}
}
